var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"integrations-holder"},[_c('div',{staticClass:"cpanel-logo"}),_vm._v(" "),_c('h3',[_vm._v(" Integrations ")]),_vm._v(" "),_c('p',[_vm._v(" SitePreviewer has cPanel support")])])
}]

export { render, staticRenderFns }